import { Button, Grid, Spacer, Text, useMediaQuery } from '@geist-ui/react'
import { useNavigate } from 'react-router-dom'

import { ReactComponent as LogoSvg1 } from '../../assets/graphic-logo-1.svg'
import { ReactComponent as LogoSvg2 } from '../../assets/graphic-logo-2.svg'
import { ReactComponent as LogoSvg3 } from '../../assets/graphic-logo-3.svg'
import { ReactComponent as LogoSvg4 } from '../../assets/graphic-logo-4.svg'

import { ReactComponent as LogoSvg1BW } from '../../assets/graphic-logo-1-bw.svg'
import { ReactComponent as LogoSvg2BW } from '../../assets/graphic-logo-2-bw.svg'
import { ReactComponent as LogoSvg3BW } from '../../assets/graphic-logo-3-bw.svg'

import { ReactComponent as LogoSvgCV } from '../../assets/logo-cv.svg'
import { projects } from '../projects'

export const Graphic = () => {
  const navigate = useNavigate()

  const isXs = useMediaQuery('xs')
  const isMdUp = useMediaQuery('md', { match: 'up' })

  const fontSize = isMdUp ? '50px' : '30px'

  // Map from project key to project id
  const projectsFromMQ = projects(isMdUp)
  const projectNameToId = Object.fromEntries(
    Object.entries(projectsFromMQ.graphic).map(([id, { key }]) => [key, id])
  )

  return (
    <Grid.Container gap={0} justify='center'>
      {/* Title */}
      <Grid style={{ marginBottom: '20px' }} xs={24} justify='center'>
        <Text className='lato-light' font={fontSize}>GRAPHIC DESIGN</Text>
      </Grid>

      {/* Icons */}
      {
        !isXs && (
          <Grid style={{ marginBottom: '50px' }} xs={24} justify='center'>
            <Grid.Container gap={1} justify='center'>
              <Grid xs={4}>
                <LogoSvg1 />
              </Grid>
              <Grid xs={4}>
                <LogoSvg2 />
              </Grid>
              <Grid xs={4}>
                <LogoSvg3 />
              </Grid>
              <Grid xs={4}>
                <LogoSvg4 />
              </Grid>
            </Grid.Container>
          </Grid>
        )
      }

      {/* Exhibition design section */}
      <Grid className='background-magenta' style={{ width: '100%', padding: '30px' }}>
        <Grid.Container gap={1} justify='center'>

          {/* Icon & Title */}
          <Grid xs={24} md={4} justify='center'>
            <Grid.Container justify='center'>
              <Grid xs={24} justify='center'>
                <LogoSvg1BW />
              </Grid>
              <Grid xs={24} justify='center'>
                <Text className='lato-light text-center' font='30px'>EXHIBITION DESIGN</Text>
              </Grid>
            </Grid.Container>
          </Grid>

          {/* Main content of the section */}
          <Grid xs={24} md={18} justify='center'>
            <Grid.Container gap={2} justify='space-around'>
              <Grid xs={24} justify='center'>
                <Text className='lato' font='16px'>
                  I progetti degli spazi espositivi museali sono stati seguiti dalle prime fasi di progettazione grafica e di modellazione 3D, alla  realizzazione ed, infine, all'allestimento in loco.
                  Sono state realizzate grafiche, espositori e supporti tenendo  conto del target d'utenza dei musei committenti sia per la scelta della palette di colori che per l'uso di font altamente leggibili e moderni, con lo scopo di riprogettare sale con opere  e manufatti già presenti, o allestire nuove mostre temporanee.
                  Di seguito una raccolta dei miei migliori lavori di Exhibition Design.
                </Text>
              </Grid>
              {/* Links to subsections */}
              <Grid xs={20} justify='center'>
                <Grid.Container gap={1} justify='center'>
                  <Grid xs={24} md={8} justify='center'>
                    <Button
                      style={{ width: '100%', borderRadius: '25px', border: '1px solid black', background: 'transparent' }}
                      onClick={() => navigate(`./${projectNameToId['museo-preistorico']}`)}
                    >
                      <Text className='lato'>Museo dei Balzi Rossi</Text>
                    </Button>
                  </Grid>
                  <Grid xs={24} md={8} justify='center'>
                    <Button
                      style={{ width: '100%', borderRadius: '25px', border: '1px solid black', background: 'transparent' }}
                      onClick={() => navigate(`./${projectNameToId['museo-luni']}`)}
                    >
                      <Text className='lato'>Museo di Luni</Text>
                    </Button>
                  </Grid>
                  <Grid xs={24} md={8} justify='center'>
                    <Button
                      style={{ width: '100%', borderRadius: '25px', border: '1px solid black', background: 'transparent' }}
                      onClick={() => navigate(`./${projectNameToId['galleria-puglia']}`)}
                    >
                      <Text className='lato'>Galleria Nazionale della Puglia</Text>
                    </Button>
                  </Grid>
                </Grid.Container>
              </Grid>
            </Grid.Container>
          </Grid>

        </Grid.Container>
      </Grid>

      <Spacer h={2} />

      {/* Brand identity section */}
      <Grid className='background-yellow' style={{ width: '100%', padding: '30px' }}>
        <Grid.Container gap={1} justify='center'>

          {/* Icon & Title in mobile view */}
          {
            isXs && (
              <Grid xs={24} md={4} justify='center'>
                <Grid.Container justify='center'>
                  <Grid xs={24} justify='center'>
                    <LogoSvg2BW />
                  </Grid>
                  <Grid xs={24} justify='center'>
                    <Text className='lato-light text-center' font='30px'>BRAND IDENTITY</Text>
                  </Grid>
                </Grid.Container>
              </Grid>
            )
          }

          {/* Main content of the section */}
          <Grid xs={24} md={18} justify='center'>
            <Grid.Container gap={2} justify='space-around'>
              <Grid xs={24} justify='center'>
                <Text className='lato' font='16px'>
                  La progettazione di un efficace brand identity parte dal logo: l'elemento visivo che più rappresenta e identifica un'azienda. Il logo viene studiato e condiviso con il  cliente per trovare il segno grafico che rispecchi la mission e la vision dell’azienda e che sia in grado di posizionarla nel mercato off line e nel digitale.
                  La comunicazione visiva aziendale è indispensabile per rendere riconoscibile ai consumatori il marchio, grazie ad uno studio attento del segno e della palette di colori.
                  Di seguito una raccolta dei miei migliori lavori di Brand Identity.
                </Text>
              </Grid>
              {/* Links to subsections */}
              <Grid xs={20} justify='center'>
                <Grid.Container gap={1} justify='center'>
                  <Grid xs={24} md={8} justify='center'>
                    <Button
                      style={{ width: '100%', borderRadius: '25px', border: '1px solid black', background: 'transparent' }}
                      onClick={() => navigate(`./${projectNameToId['sos-wedding']}`)}
                    >
                      <Text className='lato'>SOS Wedding & Event</Text>
                    </Button>
                  </Grid>
                  <Grid xs={24} md={8} justify='center'>
                    <Button
                      style={{ width: '100%', borderRadius: '25px', border: '1px solid black', background: 'transparent' }}
                      onClick={() => navigate(`./${projectNameToId['p38-regis']}`)}
                    >
                      <Text className='lato'>P38 REGIS</Text>
                    </Button>
                  </Grid>
                  <Grid xs={24} md={8} justify='center'>
                    <Button
                      style={{ width: '100%', borderRadius: '25px', border: '1px solid black', background: 'transparent' }}
                      onClick={() => navigate(`./${projectNameToId['bologna-sui-muri']}`)}
                    >
                      <Text className='lato'>BOLOGNA sui muri</Text>
                    </Button>
                  </Grid>
                </Grid.Container>
              </Grid>
            </Grid.Container>
          </Grid>

          {/* Icon & Title in desktop view */}
          {
            !isXs && (
              <Grid xs={24} md={4} justify='center'>
                <Grid.Container justify='center'>
                  <Grid xs={24} justify='center'>
                    <LogoSvg2BW />
                  </Grid>
                  <Grid xs={24} justify='center'>
                    <Text className='lato-light text-center' font='30px'>BRAND IDENTITY</Text>
                  </Grid>
                </Grid.Container>
              </Grid>
            )
          }

        </Grid.Container>
      </Grid>

      <Spacer h={2} />

      {/* Marketing illustration section */}
      <Grid className='background-cyan' style={{ width: '100%', padding: '30px' }}>
        <Grid.Container gap={1} justify='center'>

          {/* Icon & Title */}
          <Grid xs={24} md={4} justify='center'>
            <Grid.Container justify='center'>
              <Grid xs={24} justify='center'>
                <LogoSvg3BW />
              </Grid>
              <Grid xs={24} justify='center'>
                <Text className='lato-light text-center' font='30px'>MARKETING ILLUSTRATION</Text>
              </Grid>
            </Grid.Container>
          </Grid>

          {/* Main content of the section */}
          <Grid xs={24} md={18} justify='center'>
            <Grid.Container gap={2} justify='space-around'>
              <Grid xs={24} justify='center'>
                <Text className='lato' font='16px'>
                  Il Marketing illustration è la produzione  personalizzata di illustrazioni per l'azienda con lo scopo di  realizzare progetti grafici per prodotti su misura.
                  Le illustrazioni rispecchiano in stile e colori l'identità aziendale e possono essere utilizzate per creare icone personalizzate, mascotte aziendali, merchandising per compagne  pubblicitarie, packaging e linee di prodotto specifiche.
                  Di seguito una raccolta dei miei migliori lavori di Marketing illustration.
                </Text>
              </Grid>
              {/* Links to subsections */}
              <Grid xs={20} justify='center'>
                <Grid.Container gap={1} justify='center'>
                  <Grid xs={24} md={8} justify='center'>
                    <Button
                      style={{ width: '100%', borderRadius: '25px', border: '1px solid black', background: 'transparent' }}
                      onClick={() => navigate(`./${projectNameToId['ecoeridania']}`)}
                    >
                      <Text className='lato'>Ecoeridania S.p.a</Text>
                    </Button>
                  </Grid>
                  <Grid xs={24} md={8} justify='center'>
                    <Button
                      style={{ width: '100%', borderRadius: '25px', border: '1px solid black', background: 'transparent' }}
                      onClick={() => navigate(`./${projectNameToId['terrazza-bonsai']}`)}
                    >
                      <Text className='lato'>Terrazza Bonsai</Text>
                    </Button>
                  </Grid>
                  <Grid xs={24} md={8} justify='center'>
                    <Button
                      style={{ width: '100%', borderRadius: '25px', border: '1px solid black', background: 'transparent' }}
                      onClick={() => navigate(`./${projectNameToId['falconeri-sanremo']}`)}
                    >
                      <Text className='lato'>Falconeri per SANREMO</Text>
                    </Button>
                  </Grid>
                </Grid.Container>
              </Grid>
            </Grid.Container>
          </Grid>

        </Grid.Container>
      </Grid>

      <Spacer h={2} />

      {/* CV section */}
      <Grid style={{ width: '100%', backgroundColor: 'White', padding: '30px' }}>
        <Grid.Container gap={1} justify='center'>

          {/* Icon & Title in mobile view */}
          {
            isXs && (
              <Grid xs={24} md={4} justify='center'>
                <Grid.Container justify='center'>
                  <Grid xs={24} justify='center'>
                    <LogoSvgCV />
                  </Grid>
                  <Grid xs={24} justify='center'>
                    <Text className='lato-light text-center' font='30px'>CURRICULUM VITAE</Text>
                  </Grid>
                </Grid.Container>
              </Grid>
            )
          }

          {/* Main content of the section */}
          <Grid xs={24} md={18} justify='center'>
            <Grid.Container gap={2} justify='space-around'>
              <Grid xs={24} justify='center'>
                <Text className='lato' font='16px'>
                  Mi chiamo Nora Gallia e lavoro nel campo della comunicazione e della  grafica. Il mio lavoro come libero professionista mi ha resa capace di gestire contemporaneamente e in completa autonomia  diversi tipi di progetto, sempre rispettando le dead line concordate con il cliente.
                  Mi piace il mio lavoro e seguo i progetti  con precisione e passione. Il mio parco clienti è estremamente eterogeneo, questo mi ha portato ad essere sensibile e attenta ad ogni genere di richiesta, riuscendomi ad  allineare già dal primo brief con le richieste del cliente. Sono determinata e motivata ad imparare cose nuove e a crescere lavorativamente.
                </Text>
              </Grid>
              {/* Links to subsections */}
              <Grid xs={20} justify='center'>
                <Grid.Container gap={1} justify='center'>
                  <Grid xs={24} md={8} justify='center'>
                    <Button
                      style={{ width: '100%', borderRadius: '25px', border: '1px solid black', background: 'transparent' }}
                      onClick={() => navigate('../cv')}
                    >
                      <Text className='lato'>Curriculum Vitae</Text>
                    </Button>
                  </Grid>
                </Grid.Container>
              </Grid>
            </Grid.Container>
          </Grid>

          {/* Icon & Title in desktop view */}
          {
            !isXs && (
              <Grid xs={24} md={4} justify='center'>
                <Grid.Container justify='center'>
                  <Grid xs={24} justify='center'>
                    <LogoSvgCV />
                  </Grid>
                  <Grid xs={24} justify='center'>
                    <Text className='lato-light text-center' font='30px'>CURRICULUM VITAE</Text>
                  </Grid>
                </Grid.Container>
              </Grid>
            )
          }

        </Grid.Container>
      </Grid>

      <Spacer h={6} />

    </Grid.Container>
  )
}
